export const locales = ['en', 'de', 'jp'];
export const COURSE_HERO_IMAGE_WIDTH = 640;
export const COURSE_HERO_IMAGE_WIDTH_LARGE = 1146;
export const CARD_HERO_IMAGE_WIDTH = 512;
export const NON_SEARCHABLE = 'live-instructor-led';

export default {
  currentYear: new Date().getFullYear(),
  siteID: {
    default: 'a5ac163e-67f5-4464-aad1-faac2d05dbea',
  },
  commentToolbar: [
    ['bold', 'italic', 'underline', 'strike', 'link'],
    [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
    ['blockquote'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ indent: '-1' }, { indent: '+1' }],
    ['clean'],
  ],
  locales,
  localeParam: 'locale',
};
